import { render, staticRenderFns } from "./AdPos.vue?vue&type=template&id=4b5e7a9a&"
import script from "./AdPos.vue?vue&type=script&lang=js&"
export * from "./AdPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports